import type { Player } from "@/entities/Player";
import type { Monster } from "@/entities/Monster";

export type FieldTheme = "lorencia_outskirt" | "noria" | "devias" | "atlans" | "tarkan" | "icarus" | "kalima" | "crywolf";

// Map keys consumed by FieldScene + the .map.tsx registry. A superset of
// FieldTheme that also includes town, dungeon and event maps.
export type MapKey =
  | FieldTheme
  | "lorencia"
  | "dungeon"
  | "blood_castle"
  | "devil_square"
  | "chaos_castle"
  | "illusion_temple"
  | "castle_siege"
  | "golden_invasion"
  | "hero_dungeon";

export const FIELD_W = 60; // tiles
export const FIELD_H = 40;
export const TILE = 32;
export const FIELD_PIX_W = FIELD_W * TILE;
export const FIELD_PIX_H = FIELD_H * TILE;

export const JOIN = "field.join";
export const MOVE = "field.move";
export const ATTACK = "field.attack";
export const PICKUP = "field.pickup";
export const PICKUPEQUIP = "field.pickupequip";
export const USEITEM = "field.useitem";
export const STATE = "state";

// Per-class basic-attack range (pixels). Mirror of server constants in field.go.
// Tile = 32px. PRD: Warrior melee, Wizard magic, Archer ranged.
export const CLASS_ATTACK_RANGE: Record<
  "warrior" | "wizard" | "archer",
  number
> = {
  warrior: 96, // ~3 tiles
  wizard: 288, // ~9 tiles
  archer: 352, // ~11 tiles
};

export function classRange(klass: string): number {
  return (
    (CLASS_ATTACK_RANGE as Record<string, number>)[klass] ??
    CLASS_ATTACK_RANGE.warrior
  );
}

// Mirror of server-side `monAtkRange` in field_ai.go. The danger radius beyond
// which monsters cannot land a basic attack.
export const MONSTER_ATTACK_RANGE = 72;

export interface SkillTpl {
  id: number;
  name: string;
  class: string;
  cooldownMs: number;
  manaCost: number;
  rangeM?: number;
}

// Convenience type re-exports used by helper modules.
export type { Player, Monster };
